import { AudiencePointBalanceTargetingAttributeFragment } from '@occc/graphql';

import { audienceFormInitialValues } from '../../../AudienceCreatePage/AudienceFormInitialValues';
import { PointBalanceValues } from '../../types';

export const getPointBalanceInitialValues = (
  pointBalance: AudiencePointBalanceTargetingAttributeFragment | undefined,
): PointBalanceValues | undefined => {
  if (!pointBalance) {
    return audienceFormInitialValues['pointBalance'];
  }

  const { pointBalanceOperator, pointBalanceAmount, target, minAmount, maxAmount } = pointBalance;

  if (!pointBalanceOperator) {
    return {
      operator: 'BETWEEN',
      points: minAmount,
      toPoints: maxAmount,
      period: target,
    };
  }

  return {
    operator: pointBalanceOperator,
    points: pointBalanceAmount,
    period: target,
  };
};
